import { render, staticRenderFns } from "./ChallengesNotEvaluated.vue?vue&type=template&id=449880e9&"
import script from "./ChallengesNotEvaluated.vue?vue&type=script&lang=js&"
export * from "./ChallengesNotEvaluated.vue?vue&type=script&lang=js&"
import style0 from "./ChallengesNotEvaluated.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports